export const HOME='home'
export const DASHBOARD='dashboard'
export const ASSESSMENTS='assessments'
export const PROJECTS='projects'
export const FRIENDS='friends'
export const REPORTS='reports'
export const FAQ='faq'
export const LESSON='lesson'
export const PROJECT ='project'
export const Dashboard='dashboard'
export const Learning = 'learning'
export const Assessment = 'assessment'
export const StudyGroup = 'studyGroup'
export const Connect = 'connect'
export const MyProject = 'proj'